import { EventBus } from '@/event-bus.js';

export default class DialerPreferentialCallEvent {
  constructor(body) {
    window.console.log(
      '%c [event]',
      'color: #F44336;',
      JSON.stringify(body, null, 4),
    );
    if (body.activeEvent) {
      EventBus.$emit('preferential-call-confirmation');
    }
  }
}
